var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataType === 'string')?_c('el-input',{attrs:{"placeholder":"value"},model:{value:(_vm.value.data),callback:function ($$v) {_vm.$set(_vm.value, "data", $$v)},expression:"value.data"}},[_c('template',{slot:"prepend"},[_vm._v("Data")])],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }